import MapBrowserEventType from "ol/MapBrowserEventType";
import {pathIs, url} from "../../utilities";
import Spinner from "../../spinner";
import axios from "axios";
import {toastAlert} from "../../toastAlert";
import {confirmModal} from "../../confirmModal";
import Masonry from 'masonry-layout';
import {clearErrors, disableButtons, enableFormBack, handleApiForm, handleValidationErrors} from "../../forms";
import {EpMap} from "../../map/map";
import {records_page} from "./records";
import {createFeatureFromCoordinates} from "../../map/utilities";
import * as $ from "jquery";

export const book_page = () => {

    let body = $('body');
    let select;
    let selectedSectors = 0;
    let sectorsTable = $('#sectorsTable');

    let sectors = JSON.parse(window._sectors ?? '[]');
    let zones = JSON.parse(window._zones ?? '[]');

    let sectorsSource;

    let isMapPage = pathIs('/app/map');
    let isRecordsPage = pathIs('/app/book');

    if (isRecordsPage) {
        records_page();
    }

    // FAVOURITE SORTING
    const isFavourite = (el) => {
        let is = $(el).data('is_favourite');
        return parseInt(is) === 1;
    }

    jQuery.fn.dataTableExt.oSort['favourite-pre'] = function (val) {
        if (isFavourite(val)) {
            return true;
        }

        return Infinity;
    };

    sectorsTable.DataTable({
        stateSave: false,
        order: [[3, 'asc'], [1, 'asc']],
        'columnDefs': [
            {
                'targets': 0,
                'orderable': false
            },
            {
                'targets': 1,
                'type': 'natural',
            },
            {
                'targets': 2,
                'orderable': false
            },
            {
                'targets': 3,
                'sType': 'favourite',
            }
        ],
    });

    let sectorsLimit = parseInt(window._sectorsLimit ?? 0);

    const generateTooltipMessage = (sector_id, type = 'onMap') => {
        let sector = sectors.find(s => parseInt(s.id) === parseInt(sector_id));
        let message = '';
        let state = '';
        let lastState = '';
        if (sector.book_records.length > 0 && (type === 'busy' || type === 'onMap')) {
                message = `
                 ${sector.book_records.map(function (record) {
                    let time = '';
                    if (Date.parse(record.start) > Date.now()){
                        state = 0;
                        time = record.start;
                    }else{
                        state = 1;
                        time = '';
                    }
                    
                    let tel = '';
                    if (record.hunter.phone_number) {
                        tel = `<br />tel: ${record.hunter.phone_number}`;
                    }
                    
                    if(state && lastState === ''){
                        lastState = state;
                        return `Zajęte przez: <br/>  ${record.hunter.user + tel}`;
                    }else if (state === lastState && state){
                        lastState = state;
                        return `${record.hunter.user + tel}`;
                    }else if(!state && lastState === '') {
                        lastState = state;
                        return `Planowane polowanie: <br/>  ${record.hunter.user + tel} <br> (${time})`;
                    }else if(state && lastState !== ''){
                        lastState = state;
                        return `<br> Zajęte przez: <br/>  ${record.hunter.user + tel}`;
                    } else {
                        lastState = state;
                        return `<br> Planowane polowanie: <br/>  ${record.hunter.user + tel} <br> (${time})`;
                    }
                    
                    
                    
                }).join('<br />')}
            `;
        }else if(sector.district_shutdown_from && (type === 'closed' || type === 'onMap')){
            message = `
                Obwód zamknięty: <br />
                ${sector.district_shutdown_from} - ${sector.district_shutdown_to} <br /> ${sector.district_shutdown_reason ? `(${sector.district_shutdown_reason})` : ''}
            `;
        }else if (sector.shutdowns.length > 0 && (type === 'closed' || type === 'onMap')) {
            message = `
                Zamknięte: <br />
                ${sector.shutdowns.map(sh => `${sh.start} - ${sh.end}${sh.reason ? ` (${sh.reason})` : ''}`).join('<br />')}
            `;
        }else if (sector.future_shutdown && (type === 'futureShutdown' || type === 'onMap')) {
            message = `
                Planowane zamknięcie: <br />
                ${sector.future_shutdown.start} - ${sector.future_shutdown.end} <br /> ${sector.future_shutdown.reason ? `(${sector.future_shutdown.reason})` : ''}
            `;
        }

        return message.trim();
    }

    $('.sectors-container [data-id]').each(function () {
        let message = generateTooltipMessage($(this).data('id'), 'onMap');
        $(this).attr('title', message);
    })

    sectorsTable.DataTable().$('.busy-badge, .closed-badge, .future-btn').each(function () {
        let type = $(this).data('type');
        $(this).attr('title', generateTooltipMessage($(this).data('id'), type));
        new bootstrap.Tooltip($(this)[0], {html: true});
    })

    sectorsTable.DataTable().$(".sector-input").change(function () {
        let container = $(".sectors-container");
        let checked = $(this).prop('checked');
        let id = $(this).val();

        let closed = $(this).data('closed');
        let busy = $(this).data('busy');

        if (checked) {
            $(".sectors-empty").hide();

            if (sectorsLimit === 0 || sectorsLimit > selectedSectors) {
                container.append(`
                        <input data-name="${$(this).data('name')}" ${closed ? 'data-closed="true"' : ''} ${busy ? 'data-busy="true"' : ''} type="hidden" name="sector_id[]" value="${id}" />
                    `);
            }

            let title = generateTooltipMessage(id);

            let div = $(`
                <div data-id="${id}"
                    style="border: 1px solid"
                     class="flex-column border-${busy ? 'danger' : (closed ? 'purple' : 'primary')} p-2 text-dark me-2 mb-2"
                     title="${title}"
                 >
                    ${$(this).data('name')}

                    <a href="#" class="ms-2 deselect-custom">x</a>
                </div>
            `);
            new bootstrap.Tooltip(div[0], {html: true});
            if (sectorsLimit === 0 || selectedSectors < sectorsLimit) {
                container.append(div);
                selectedSectors = selectedSectors + 1;
            }
        } else {
            let div = container.find(`div[data-id="${id}"]`);

            let tooltip = bootstrap.Tooltip.getInstance(div[0]);
            if (tooltip) {
                tooltip.hide();
            }

            div.remove();
            selectedSectors = selectedSectors - 1;
            container.find(`input[value="${id}"]`).remove();

            if (container.find('input[type="hidden"]').length === 0) {
                $(".sectors-empty").show();
            }
        }

        select.getFeatures().clear();
        for (let input of sectorsTable.DataTable().$('input[type="checkbox"]:checked')) {
            let feature = sectorsSource.getFeatureById($(input).val());
            if (feature) {
                select.getFeatures().push(feature);
            }
        }

        //jeżeli powyżej limitu to wyłącza pozostałe checkboxy
        if (sectorsLimit !== 0 && sectorsTable.DataTable().$('input[type="checkbox"]:checked').length >= sectorsLimit) {
            sectorsTable.DataTable().$('input[type="checkbox"]:not(:checked)').prop('disabled', true);
        } else {
            sectorsTable.DataTable().$('input[type="checkbox"]:not(:checked)').prop('disabled', false);
        }

        new Masonry('.row[data-masonry]');
    })

    // let checkedAuthorizations = $('.authorization-input:checked');
    // if (checkedAuthorizations.length > 0) {
    //     checkedAuthorizations.each(function () {
    //         let category = $(this).data('category');
    //         $(`.authorization-input:not([data-category="${category}"])`).attr('disabled', true);
    //     })
    // }

    $("body").on('change', '.authorization-input', function () {
        let container = $(".authorizations-container");
        let checked = $(this).prop('checked');
        let id = $(this).val();
        let category = $(this).data('category');

        if (checked) {
            $(".authorizations-empty").hide();
            // $(`.authorization-input:not([data-category="${category}"])`).attr('disabled', true);

            container.append(`<input type="hidden" name="authorization_id[]" value="${id}" />`);

            let div = $(`
                <div 
                    style="border: 1px solid"
                    data-id="${id}" class="flex-column p-2 text-dark me-2 mb-2 border-primary">
                    ${$(this).data('number')}
                    
                    <a href="#" class="ms-2 deselect-custom">x</a>
                </div>
            `);
            container.append(div);
        } else {
            container.find(`input[value="${id}"], div[data-id="${id}"]`).remove();
            // if ($('.authorization-input:checked').length === 0) {
            //     $(`.authorization-input`).attr('disabled', false);
            // }

            if (container.find('input[type="hidden"]').length === 0) {
                $(".authorizations-empty").show();
            }
        }

        new Masonry('.row[data-masonry]');
    })

    body.on('click', '.deselect-custom', function () {
        let id = $(this).closest('div').data('id');
        let modal = $("#" + $(this).closest('[data-custom-modal]').data('custom-modal'));

        let input;

        if (modal.find('table').hasClass('dataTable')) {
            input = modal.find('table').DataTable().$(`input[type="checkbox"][value="${id}"]`);
        } else {
            input = modal.find(`input[type="checkbox"][value="${id}"]`);
        }

        input.prop('checked', false);
        input.trigger('change');
    })

    /// Map
    let mapContainer = $("#map");
    const changeMapSize = () => {
        let height = 400;

        if (isMapPage) {
            height = $("section.content").innerHeight() - $("#select-map-row").outerHeight(true);
        }

        mapContainer.height(height - 32);
    }
    changeMapSize();

    if (mapContainer.length > 0) {

        let epMap = new EpMap({target: 'map', hideLabelsIfNecessary: true});
        let map = epMap.getOlMap();

        let sectorsLayer = epMap.addSectorsLayer().getLayer();
        sectorsSource = sectorsLayer.getSource();

        let boundariesLayer = epMap.addBoundariesLayer().getLayer();
        let boundariesSource = boundariesLayer.getSource();

        if(window._boundaries) {
            let feature = createFeatureFromCoordinates(window._boundaries, 'boundaries');
            boundariesSource.addFeature(feature);
        }

        if(sectors.length > 0) {
            epMap.sectors.addSectorsFromObject(sectors);
            epMap.sectors.fitInView();
        }

        epMap.addZonesLayer().getLayer();
        epMap.zones.addZonesFromObject(zones);

        let devicesEpLayer = epMap.addDevicesLayer();
        let devices = JSON.parse(window._devices ?? '[]');
        devicesEpLayer.addDevicesFromObject(devices);
        
        epMap.hideLabelsIfNecessary();

        let tooltipVisible = false;
        let tooltip = $(".map-tooltip");

        map.on('pointermove', (event) => {
            let f = null;

            map.forEachFeatureAtPixel(event.pixel, (feature) => {
                f = feature;
            });

            if (f !== null && f.get('type') === 'sector' && ((f.get('sector-data').shutdowns.length > 0 || f.get('sector-data').book_records.length > 0) || f.get('sector-data').district_shutdown_from || f.get('sector-data').future_shutdown)) {
                let data = f.get('sector-data');
                tooltip.html(generateTooltipMessage(data.id));

                tooltip.css({
                    'left': event.pixel[0] + mapContainer[0].offsetLeft,
                    'bottom': (mapContainer.height() - event.pixel[1] + 32)
                })

                if (!tooltipVisible) {
                    tooltip.show();
                    tooltipVisible = true;
                }
            } else {
                if (tooltipVisible) {
                    tooltip.hide();
                    tooltipVisible = false;
                }
            }
        })

        select = epMap.addSelect([sectorsLayer], {
            multi: true, toggleCondition: function (e) {
                return e.type === MapBrowserEventType.SINGLECLICK;
            },
        })

        if (typeof is_controller == 'undefined') {
            map.addInteraction(select);
        }

        select.on('select', function (e) {
            let selected = e.selected;
            let deselected = e.deselected;

            if (isMapPage && e.selected.length > 0 && !window._is_archival_season) {
                new Spinner();
                window.location = url(`app/book/sign-in?sector_id=${e.selected[0].getId()}`);
                return;
            }

            select.getFeatures().clear();


            if (sectorsLimit === 0 || sectorsLimit > selectedSectors) {
                for (let feature of selected) {
                    sectorsTable.DataTable().$(`[value="${feature.getId()}"]`).prop('checked', true).trigger('change');
                }
            } else {
                sectorsTable.DataTable().$("input[type='checkbox']:checked").each(function () {
                    select.getFeatures().push(sectorsSource.getFeatureById($(this).val()));
                })
            }

            for (let feature of deselected) {
                sectorsTable.DataTable().$(`[value="${feature.getId()}"]`).prop('checked', false).trigger('change');
            }
        })

        if (isMapPage) {
            map.on('pointermove', (e) => {
                const pixel = map.getEventPixel(e.originalEvent);
                const hit = map.hasFeatureAtPixel(pixel);
                if (typeof is_controller == 'undefined') {
                    document.getElementById('map').style.cursor = hit ? 'pointer' : '';
                }
            });
        }

        sectorsTable.DataTable().$("input[type='checkbox']:checked").each(function () {
            select.getFeatures().push(sectorsSource.getFeatureById($(this).val()));
        })
    }

    /// Change of user
    $("input[name='user_id']").change(async function () {
        let user_id = $(this).val();

        if (user_id === 0) {
            return;
        }

        let spinner = new Spinner(null, null, 'book');

        try {
            let response = await axios.get(url(
                `api/authorizations/of/${user_id}`
            ));
            if (response.data.code !== 200) {
                toastAlert('Wystąpił błąd podczas próby załadowania upoważnień. Spróbuj ponownie później.', {type: 'danger'});
            }

            let oldLimit = sectorsLimit;
            sectorsLimit = parseInt(response.data.newLimit ?? 0);
            if (sectorsLimit < oldLimit && sectorsLimit !== 0 || oldLimit === 0 && sectorsLimit !== 0) {
                toastAlert('Wybrana osoba posiada limit sektorów w polowaniu: ' + sectorsLimit);
            }

            let authorizations = response.data.authorizations;
            let modal = $("#authorizationsModal");
            let tbody = modal.find('tbody');

            tbody.empty();
            for (let authorization of authorizations) {
                tbody.append(
                    `
                    <tr>
                        <td>
                            <input data-number="${authorization.number}" type="checkbox"
                                data-category="${authorization.authorization_category_id}"
                                class="form-check authorization-input"
                                value="${authorization.id}"/>
                        </td>
                        <td>${authorization.number}</td>
                    </tr>
                `);
            }

            let container = $(".authorizations-container");
            container.find(`input[value], div[data-id]`).remove();

            if (container.find('input[type="hidden"]').length === 0) {
                $(".authorizations-empty").show();
            }

            if (authorizations.length > 0) {
                tbody.find('input[type="checkbox"]:first').prop('checked', true).trigger('change');
            }
        } catch (err) {
            toastAlert('Wystąpił błąd podczas próby załadowania upoważnień. Spróbuj ponownie później.', {type: 'danger'});
        }

        spinner.destroy();

    })

    $("#bookSignIn").submit(async function (e) {
        e.preventDefault();

        let confirmRequired = [];

        if ($("input[name='district_closed'][value='true']").length > 0) {
            confirmRequired = [...confirmRequired, `w zamkniętym obwodzie łowieckim`];
        }

        $(".sectors-container input[data-closed]").each(function () {
            confirmRequired = [...confirmRequired, `w zamkniętym miejscu polowań (${$(this).data('name')})`];
        });

        $(".sectors-container input[data-busy]").each(function () {
            confirmRequired = [...confirmRequired, `w zajętym miejscu polowań (${$(this).data('name')})`];
        });

        $(".sectors-container input[data-future]").each(function () {
            confirmRequired = [...confirmRequired, `w miejscu, gdzie zaplanowano polowanie (${$(this).data('name')})`];
        });

        $(".sectors-container input[data-fshutdown]").each(function () {
            confirmRequired = [...confirmRequired, `w miejscu, którego zamknięcie zaplanowano (${$(this).data('name')})`];
        });

        let confirmed;
        if (confirmRequired.length > 0) {
            let text = $("<span>Czy jesteś pewny/a, że chcesz wpisać się na polowanie: </span>");
            let list = $("<ul />");
            text.append(list);

            for (let confirm of confirmRequired) {
                list.append(`<li>${confirm}</li>`)
            }
            confirmed = await confirmModal(text.html(), {hideAfterResolve: false});
        } else {
            confirmed = true;
        }

        if (confirmed) {
            this.submit();
            disableButtons();
        }
    })

    sectorsTable.DataTable().$(".btnFavouriteSectorModify").click(async function (e) {

        e.preventDefault();

        let sector_id = $(this).data('id');
        let is_favourite = $(this).data('is_favourite');

        let spinner = new Spinner(null, null, 'book');

        try {
            let response = await axios.post(url(`api/book/sign-in/favourite-sector-modify`), {
                is_favourite: is_favourite,
                sector_id: sector_id
            });
            if (parseInt(response.data['is_favourite']) === 0 && response.data['status'] === 200) {
                $(this).data({'is_favourite': response.data['is_favourite']});
                $(this).toggleClass('text-warning');
                $(this).toggleClass('book-favourite');

                toastAlert('Pomyślnie usunięto miejsce z ulubionych');
            } else if (parseInt(response.data['is_favourite']) === 1 && response.data['status'] === 200) {
                $(this).data({'is_favourite': response.data['is_favourite']});
                $(this).toggleClass('text-warning');
                $(this).toggleClass('book-favourite');

                toastAlert('Pomyślnie dodano do ulubionych');
            } else {
                toastAlert('Niepowodzenie przy wykonywaniu operacji', {type: "danger"});
            }

        } catch (err) {
            toastAlert('Niepowodzenie przy wykonywaniu operacji', {type: "danger"})
        }

        spinner.destroy();
    });

    /// Dodawanie zwierzyny w widoku kończenia polowania
    let shouldFetchNewData = true;
    let animals = [], authorizations = [];
    let addAnimalForm = $("#bookAddAnimal");

    if (addAnimalForm.length > 0) {
        let animalTypesSelect = addAnimalForm.find('select[name="animal_type_id"]');
        let animalSelect = addAnimalForm.find('select[name="animal_id"]');
        let authorizationSelect = addAnimalForm.find('select[name="authorization_id"]');

        handleApiForm(addAnimalForm, function ({response}) {
            let modalInstance = bootstrap.Modal.getInstance(document.getElementById("animalsModal"));
            modalInstance.hide();

            let record_animal = response.data.record_animal;

            if(!record_animal.identifier_district_veterinarian || record_animal.identifier_district_veterinarian == ''){
                record_animal.identifier_district_veterinarian = '-';
            }

            if(!record_animal.identifier_direct_sale || record_animal.identifier_direct_sale == ''){
                record_animal.identifier_direct_sale = '-';
            }

            if(!record_animal.identifier || record_animal.identifier == ''){
                record_animal.identifier = '-';
            }

            let row = $(`
                <tr data-id="${record_animal.id}">
                    <td class="record_animal__name">${record_animal.animal.display_name}</td>
                    <td class="record_animal__intendedUse">${record_animal.intendedUse.name}</td>
                    <td class="record_animal__collection_centre">
                        ${record_animal.collection_centre_name}
                        ${(record_animal.number_mp && record_animal.number_mp.length > 0) ? `<br />(Numer MP: ${record_animal.number_mp})` : ''}
                    </td>
                    <td class="record_animal__identifier">${record_animal.identifier} / ${record_animal.identifier_district_veterinarian} / ${record_animal.identifier_direct_sale}</td>
                    <td class="record_animal__weight">${record_animal.weight ?? ""}</td>
                    <td class="record_animal__quantity">${record_animal.quantity}</td>
                    ${extendedAuthorizations ? `<td class="record_animal__authorization">${record_animal.authorization ? record_animal.authorization.number : 'Brak'}</td>` : ''}
                    <td class="record_animal__hunting_date">${record_animal.hunting_date ? moment(record_animal.hunting_date).format("HH:mm") : '-'}</td>
                </tr>
            `);

            let td = $(`
                <td>
                    <button data-bs-target="#editAnimalsModal"
                            data-id="${record_animal.id}"
                            data-bs-toggle="modal"
                            data-url="${url(`api/book/${record_animal.book_record_id}/available-animals`)}"
                            data-record_animal_url="${url(`api/book/${record_animal.book_record_id}/animal/${record_animal.id}`)}"
                            type="button" class="btn btn-primary btn-sm text-nowrap me-1 mb-1">
                        <i class="fas fa-pen me-2"></i>
                        Edytuj
                    </button>
                </td>
            `);
            row.append(td);

            let form = $(`
                <form class="d-inline-block deleteAnimal" method="post" action="${url(`api/book/${record_animal.book_record_id}/delete-animal`)}">
                    <input type="hidden" name="_token" value="${$('meta[name="csrf-token"]').attr('content')}" />
                    <input type="hidden" name="id" value="${record_animal.id}">
                    <button class="btn btn-sm btn-danger btn-delete-message me-1 mb-1">
                        <i class="fas fa-trash me-2"></i>Usuń
                    </button>
                </form>
            `);
            td.append(form);


            //Dodanie przycisku ZIPOD
            let zipodButton ;
            if(parseInt(record_animal.animal.type.is_zipodable) === 1){
                zipodButton = $(`
                    <a class="btn btn-primary btn-sm text-nowrap me-1 mb-1 zipodButton" href="${url(`app/zipod/${record_animal.id}/add`)}">
                        ZIPOD
                    </a>
                `)
                td.prepend(zipodButton);
            }

            $("#animalsTable").DataTable().api().rows.add(row).draw();

            toastAlert('Zwierzyna została pomyślnie dodana');
            shouldFetchNewData = true;

            addAnimalForm.find('input[name="quantity"]').val(1);
            addAnimalForm.find('input[name="identifier"]').val("");
            addAnimalForm.find('input[name="weight"]').val("");
            addAnimalForm.find('input[name="number_mp"]').val("");
        })

        /// Zmiana zwierzyny
        animalTypesSelect.change(function () {
            let spinner = new Spinner(null, null, 'book');

            let option = $(this).find(`option[value="${$(this).val()}"]`);
            if (!option.data('is_big')) {
                addAnimalForm.find('input[name="quantity"]').attr('disabled', false);
                addAnimalForm.find('input[name="weight"]').parent().parent().hide();
            } else {
                animalSelect.parent().parent().show();
                addAnimalForm.find('input[name="quantity"]').val(1).attr('disabled', true);
                addAnimalForm.find('input[name="weight"]').parent().parent().show();
            }

            if(!option.data('has_many_animals')) {
                animalSelect.parent().parent().hide();
            }else{
                animalSelect.parent().parent().show();
            }

            animalSelect.html('');
            for (let animal of animals) {
                if (animal.animal_type_id !== $(this).val()) {
                    continue;
                }

                animalSelect.append(`<option value="${animal.id}">${animal.name}</option>`);
            }
            animalSelect.trigger('change');
            spinner.destroy();
        })

        animalSelect.change(function () {
            let spinner = new Spinner(null, null, 'book');
            let animal = animals.find(a => a.id === $(this).val());

            authorizationSelect.html('');

            if (!animal) {
                return;
            }


            for (let authorization of authorizations) {
                let a = animal.authorizations.find(x => parseInt(x.id) === parseInt(authorization.id));
                if (!a || typeof a == 'undefined' || a.quantity < 1) {
                    continue;
                }

                if (parseInt(authorization.id) === 0) {
                    authorizationSelect.append(`<option value="0">${authorization.number}</option>`);
                    continue;
                }

                authorizationSelect.append(`<option value="${authorization.id}">${authorization.number} (${a.quantity} szt.)</option>`);
            }

            spinner.destroy();
        })

        /// Otwarcie modalu - załadowanie danych (jeśli konieczne)
        $("button[data-bs-target=\"#animalsModal\"]").click(async function () {
            if (!shouldFetchNewData) {
                return;
            }

            shouldFetchNewData = false;
            let spinner = new Spinner(null, null, 'book');

            try {
                let response = await axios.get($(this).data('url'));
                if (response.data.code !== 200) {
                    toastAlert('Nie udało się załadować danych potrzebnych do dodania zwierzyny. Spróbuj ponownie później.', {type: 'danger'});
                    return;
                }

                if (response.data.animals.length === 0) {
                    let title = 'Brak dostępnych zwierząt na wybranych upoważnieniach. Skontaktuj się z łowczym.';

                    toastAlert(title, {type: 'danger'})
                    $(this).attr('disabled', true);
                    $(this).parent().attr('title', title);

                    spinner.destroy();
                    let modal = $("#animalsModal");
                    modal.find("#addAnimalModalNoAnimals").show();
                    modal.find("#addAnimalModalContent").hide();
                    modal.find('button[type="submit"]').attr('disabled', true);

                    new bootstrap.Tooltip($(this).parent()[0]);
                    return;
                }

                animals = response.data.animals;
                authorizations = response.data.authorizations;

                animalTypesSelect.html('');
                let invasiveOptGroup = $(`<optgroup label="Gatunki inwazyjne"></optgroup>`);
                let invasiveTypes = [];
                for (let animalType of response.data.animalTypes) {
                    if(parseInt(animalType.is_invasive) === 0) {
                        animalTypesSelect.append(`<option data-is_big="${animalType.is_big}" data-has_many_animals="${animalType.hasManyAnimals}" value="${animalType.id}">${animalType.name}</option>`);
                    }else{
                        invasiveTypes.push(animalType);
                    }
                }

                if(invasiveTypes.length > 0){
                    for (let animalType of invasiveTypes) {
                        invasiveOptGroup.append(`<option data-is_big="${animalType.is_big}" data-has_many_animals="${animalType.hasManyAnimals}" value="${animalType.id}">${animalType.name}</option>`);

                    }
                    animalTypesSelect.append(invasiveOptGroup);
                }

                animalTypesSelect.trigger('change');

                spinner.destroy();
            } catch (err) {
                toastAlert('Nie udało się załadować danych potrzebnych do dodania zwierzyny. Spróbuj ponownie później.', {type: 'danger'});
            }
        })
    }

    /// Edycja zwierzyny w widoku kończenia polowania
    (() => {
        let animals = [], authorizations = [];
        let editAnimalForm = $("#bookEditAnimal");
        let id, row, record_animal, shouldTriggerAnimalChange = false;

        let animalTypesSelect = editAnimalForm.find('select[name="animal_type_id"]');
        let animalSelect = editAnimalForm.find('select[name="animal_id"]');
        let authorizationSelect = editAnimalForm.find('select[name="authorization_id"]');

        handleApiForm(editAnimalForm, function ({response}) {
            let modalInstance = bootstrap.Modal.getInstance(document.getElementById("editAnimalsModal"));
            modalInstance.hide();

            toastAlert('Zwierzyna została pomyślnie edytowana');
            shouldFetchNewData = true;

            editAnimalForm.find('input[name="quantity"]').val(1);
            editAnimalForm.find('input[name="identifier"]').val("");
            editAnimalForm.find('input[name="weight"]').val("");
            editAnimalForm.find('input[name="number_mp"]').val("");


            record_animal = response.data.record_animal;

            if(!record_animal.identifier_district_veterinarian || record_animal.identifier_district_veterinarian == ''){
                record_animal.identifier_district_veterinarian = '-';
            }

            if(!record_animal.identifier_direct_sale || record_animal.identifier_direct_sale == ''){
                record_animal.identifier_direct_sale = '-';
            }

            if(!record_animal.identifier || record_animal.identifier == ''){
                record_animal.identifier = '-';
            }

            row.find('.record_animal__name').text(record_animal.animal.display_name);
            row.find('.record_animal__intendedUse').text(record_animal.intendedUse.name);

            let number_mp = `${(record_animal.number_mp && record_animal.number_mp.length > 0) ? `<br />(Numer MP: ${record_animal.number_mp})` : ''}`;

            row.find('.record_animal__collection_centre').html(record_animal.collection_centre_name + number_mp);
            row.find('.record_animal__identifier').text(record_animal.identifier + ' / ' + record_animal.identifier_district_veterinarian + ' / ' + record_animal.identifier_direct_sale);
            if (record_animal.weight != null) {
                row.find('.record_animal__weight').text(parseFloat(record_animal.weight).toFixed(2));
            } else {
                row.find('.record_animal__weight').text("");
            }
            row.find('.record_animal__quantity').text(record_animal.quantity);
            if (extendedAuthorizations) {
                    row.find('.record_animal__authorization').text(record_animal.authorization ? record_animal.authorization.number : 'Brak');
            }
            row.find('.record_animal__hunting_date').text(record_animal.hunting_date ? moment(record_animal.hunting_date).format("HH:mm") : '-');

            //Dodanie przycisku ZIPOD
            let zipodButton ;
            if(parseInt(record_animal.animal.type.is_zipodable) === 1){
                zipodButton = $(`
                    <a class="btn btn-primary btn-sm text-nowrap me-1 mb-1 zipodButton" href="${url(`app/zipod/${record_animal.id}/add`)}">
                        ZIPOD
                    </a>
                `)

                let oldZipod = row.find('.zipodButton');
                if(parseInt(oldZipod.length) === 0){
                    row.find('.record_animal__actions').prepend(zipodButton);
                }
            }else{
                row.find('.zipodButton').remove();
            }

        })

        /// Zmiana zwierzyny
        animalTypesSelect.change(function () {
            let spinner = new Spinner(null, null, 'book');

            let option = $(this).find(`option[value="${$(this).val()}"]`);
            if (!option.data('is_big')) {
                editAnimalForm.find('input[name="quantity"]').attr('disabled', false);
                editAnimalForm.find('input[name="weight"]').parent().parent().hide();
            } else {
                animalSelect.parent().parent().show();
                editAnimalForm.find('input[name="quantity"]').val(1).attr('disabled', true);
                editAnimalForm.find('input[name="weight"]').parent().parent().show();
            }

            if(!option.data('has_many_animals')) {
                animalSelect.parent().parent().hide();
            }else{
                animalSelect.parent().parent().show();
            }

            animalSelect.html('');
            for (let animal of animals) {
                if (animal.animal_type_id !== $(this).val()) {
                    continue;
                }

                animalSelect.append(`<option value="${animal.id}">${animal.name}</option>`);
                if (shouldTriggerAnimalChange) {
                    animalSelect.val(animalSelect.first('option').val()).change();
                } else {
                    shouldTriggerAnimalChange = true;
                }
            }
            spinner.destroy();
        })

        animalSelect.change(function () {
            let spinner = new Spinner(null, null, 'book');
            let animal = animals.find(a => a.id === $(this).val());

            authorizationSelect.html('');

            if (!animal) {
                spinner.destroy();
                return;
            }

            for (let authorization of authorizations) {
                let a = animal.authorizations.find(x => parseInt(x.id) === parseInt(authorization.id));
                if (!a || typeof a == 'undefined' || a.quantity < 1) {
                    continue;
                }

                if (parseInt(authorization.id) === 0) {
                    authorizationSelect.append(`<option value="0">${authorization.number}</option>`);
                    continue;
                }

                authorizationSelect.append(`<option value="${authorization.id}">${authorization.number} (${a.quantity} szt.)</option>`);
            }

            spinner.destroy();
        })


        $('#bookEditAnimal_collection_centre_id, #bookAddAnimal_collection_centre_id').prepend(`<option value="0">Brak</option>`);

        /// Otwarcie modalu - załadowanie danych (jeśli konieczne)
        $("body").on('click', 'button[data-bs-target=\"#editAnimalsModal\"]', async function () {
            let spinner = new Spinner(null, null, 'book');
            row = $(`tr[data-id="${$(this).data('id')}"]`);
            id = row.data('id');

            shouldTriggerAnimalChange = false;

            editAnimalForm.find('input[name="id"]').val(id)
            try {
                let response = await axios.get($(this).data('url') + `?ignore=${id}`);
                if (response.data.code !== 200) {
                    toastAlert('Nie udało się załadować danych potrzebnych do dodania zwierzyny. Spróbuj ponownie później.', {type: 'danger'});
                    return;
                }

                animals = response.data.animals;
                authorizations = response.data.authorizations;

                let animalTypes = response.data.animalTypes;

                response = await axios.get($(this).data('record_animal_url'));
                if (response.data.code !== 200) {
                    toastAlert('Nie udało się załadować danych potrzebnych do dodania zwierzyny. Spróbuj ponownie później.', {type: 'danger'});
                    return;
                }

                record_animal = response.data.record_animal;
                animalTypesSelect.html('');

                let invasiveTypesOpt = $(`<optgroup label="Gatunki inwazyjne"></optgroup>`);
                let invasiveTypes = [];

                for (let animalType of animalTypes) {
                    if(parseInt(animalType.is_invasive) === 1){
                        invasiveTypes.push(animalType);
                    }else {
                        animalTypesSelect.append(`<option data-is_big="${animalType.is_big}" data-has_many_animals="${animalType.hasManyAnimals}" value="${animalType.id}">${animalType.name}</option>`);
                    }
                }

                if(invasiveTypes.length > 0){
                    for(let animalType of invasiveTypes){
                        invasiveTypesOpt.append(`<option data-is_big="${animalType.is_big}" data-has_many_animals="${animalType.hasManyAnimals}" value="${animalType.id}">${animalType.name}</option>`);
                    }
                    animalTypesSelect.append(invasiveTypesOpt);
                }



                animalTypesSelect.val(record_animal.animal.animal_type_id).trigger('change');
                animalSelect.val(record_animal.animal_id).trigger('change');

                if (record_animal.authorization_id == null) {
                    record_animal.authorization_id = 0;
                }

                editAnimalForm.find('select[name="authorization_id"]').val(record_animal.authorization_id).change();
                editAnimalForm.find('select[name="animal_intended_use_id"]').val(record_animal.animal_intended_use_id);
                editAnimalForm.find('select[name="collection_centre_id"]').val(record_animal.collection_centre_id ?? 0).change();
                editAnimalForm.find('input[name="number_mp"]').val(record_animal.number_mp);
                editAnimalForm.find('input[name="quantity"]').val(record_animal.quantity);
                editAnimalForm.find('input[name="identifier"]').val(record_animal.identifier);
                editAnimalForm.find('input[name="identifier_district_veterinarian"]').val(record_animal.identifier_district_veterinarian);
                editAnimalForm.find('input[name="identifier_direct_sale"]').val(record_animal.identifier_direct_sale);
                editAnimalForm.find('input[name="weight"]').val(record_animal.weight);
                editAnimalForm.find('input[name="hunting_date"]').val(record_animal.hunting_date ? moment(record_animal.hunting_date).format("HH:mm") : '');

                if (parseInt(record_animal.animal_intended_use_id) !== 1) {
                    editAnimalForm.find('select[name="collection_centre_id"]').closest('.col-12').hide();
                } else {
                    editAnimalForm.find('select[name="collection_centre_id"]').closest('.col-12').show();
                }

                spinner.destroy();
            } catch (err) {
                toastAlert('Nie udało się załadować danych potrzebnych do dodania zwierzyny. Spróbuj ponownie później.', {type: 'danger'});
            }
        })
    })()

    /// Usuwanie zwierzyny
    handleApiForm('.deleteAnimal', function ({response}) {
        let row = $(`tr[data-id="${response.data.id}"]`);
        $("#animalsTable").DataTable().api().row(row).remove().draw();

        toastAlert('Zwierzyna została pomyślnie usunięta');
        shouldFetchNewData = true;

        let button = $('button[data-bs-target=\"#animalsModal\"]');
        button.attr('disabled', false);
        let tooltip = bootstrap.Tooltip.getInstance(button.parent()[0]);
        if (tooltip) {
            tooltip.dispose()
        }

        let modal = $("#animalsModal");
        modal.find("#addAnimalModalNoAnimals").hide();
        modal.find("#addAnimalModalContent").show();
        modal.find('button[type="submit"]').attr('disabled', false);
    }, () => {
        return new Promise(async (resolve, reject) => {
            let confirm = await confirmModal('Czy na pewno chcesz usunąć tą zwierzynę?', {color: 'danger'});
            if (confirm) {
                resolve();
            }

            reject();
        })
    }, (err) => {
        if (typeof err != 'undefined') {
            toastAlert('Nie udało się usunąć zwierzyny.', {type: 'danger'});
        }
    })

    $('#bookAddAnimal_animal_intended_use_id, #bookEditAnimal_animal_intended_use_id').on('change', async function () {
        let form = $(this).closest('form');

        if (parseInt($(this).children("option:selected").val()) === 1) {
            // form.find('input[name="number_mp"]').closest('.col-12').show();
            form.find('select[name="collection_centre_id"]').closest('.col-12').show();
        } else {
            // form.find('input[name="number_mp"]').closest('.col-12').hide();
            form.find('select[name="collection_centre_id"]').closest('.col-12').hide();
        }
    });

    // Obsługa zdjęć

    $("#addAnimalAttachment_book_record_animal_id").change(async function (){

        let id = $(this).find('option:selected').val();

        try {
            let response = await axios.get(url(`api/book/${id}/attachment-count`));
            let dragNDrop = $(".input__dragndrop");
            dragNDrop.find('input[data-max]').attr('data-max', response.data.attachments_left);
            dragNDrop.find(".max_length_value").html(response.data.attachments_left);
            let dragNDropColumn = $(".drag_n_drop");
            let dragNDropColumnInfo = $(".drag_n_drop_info");

            if(parseInt(response.data.attachments_left) <= 0){
                dragNDropColumn.hide();
                dragNDropColumnInfo.show();
            }else{
                dragNDropColumn.show();
                dragNDropColumnInfo.hide();
            }

        }catch(err){
            toastAlert('Podczas pobierania danych wystąpił błąd. Spróbuj ponownie później.', {type: 'danger'});
        }
    })

    $("#addAnimalAttachment_book_record_animal_id").trigger('change');

    handleApiForm("#deleteAnimalAttachmentForm", function ({response}) {

            if(parseInt(response.data.code) === 400){
                toastAlert('Nie udało się usunąć zdjęcia.', {type: 'danger'});
                return;
            }

            let id = response.data.id;

            let table = $("#animalAttachmentsTable");

            let attachment = table.find(`tr[data-id="${id}"]`);

            attachment.remove();

            if(table.find("tbody").children().length === 0)
            {
                table.remove();
                $("#emptyAttachmentTable").html('Brak przesłanych zdjęć');
            }
            $("#addAnimalAttachment_book_record_animal_id").trigger('change');
            toastAlert('Pomyślnie usunięto zdjęcie');
        },
        () => {
            return new Promise(async (resolve, reject) => {
                let confirm = await confirmModal('Czy na pewno chcesz usunąć to zdjęcie?', {color: 'danger'});
                if (confirm) {
                    resolve();
                }
                reject();
            })
        }, (err) => {
            if (typeof err != 'undefined') {
                toastAlert('Nie udało się usunąć zdjęcia.', {type: 'danger'});
            }
        })

    $("form#addAnimalAttachment").on('file_added', function(){
        $("form#addAnimalAttachment").submit();
    })

    handleApiForm("#changeStateAnimalAttachmentForm", function ({response}) {

            if(parseInt(response.data.code) === 400){
                toastAlert('Nie udało się zmienić widoczności zdjęcia.', {type: 'danger'});
                return;
            }

            let id = response.data.id;
            let is_hidden = response.data.is_hidden;

            let table = $("#animalAttachmentsTable");
            let attachment = table.find(`tr[data-id="${id}"]`);
            let buttonHide = attachment.find('.btn-hide-attachment');
            let buttonShow = attachment.find('.btn-show-attachment');
            let input = attachment.find('input[name=is_hidden]');
            if(is_hidden){
                input.val(1);
                buttonHide.hide();
                buttonShow.show();
            }else{
                input.val(0);
                buttonHide.show();
                buttonShow.hide();
            }

            toastAlert('Pomyślnie zmieniono widoczność zdjęcia.');
        })


        $(".btn-edit-comments").click(function(){
            let content = $(this).closest('tr').find('.attachments').html();
            let textarea = $("#editAnimalAttachment_comments");
            if(content) {
                textarea.val(content);
            }
            let input = $("#attachmentId");
            let id = $(this).closest('tr').data('id');
            input.val(id);
        })

        let miniatures = $('.miniature');

        for(let min of miniatures){
            let icon = $(min);
            let height = min.height;
            let width = min.width;

            if(height > width){
                icon.css('width', 'auto');
                icon.css('height', '200px');
            }else{
                icon.css('width', '200px');
                icon.css('height', 'auto');
            }
        }

        $('button[data-bs-target="#zipodModal"]').click(async function (){
            let id = $(this).data('id');
            let rid = $(this).data('rid');
            try {
                let response = await axios.get(url(`api/book/${id}/animal/${rid}/get-zipod`));

                let data = response.data;
                if(data.report.date == "1970-01-01"){
                    data.report.date = '-';
                }
                if(data){
                    $('.zipod__status').html(data.report.statusMessage);
                    $('.zipod__date').html(data.report.date);
                    $('.zipod__created_by').html(data.author.first_name + ' ' + data.author.last_name ?? '');
                    $('.zipod__error').html(data.report.error_message);

                    if(parseInt(data.report.status) === 3){
                        $('.zipod__error_row').show();
                        let oldBtn = $('.zipodButton');
                        if(oldBtn.length === 1) {
                            oldBtn.remove();
                        }
                            let zipodButton = $(`
                            <a class="btn btn-danger text-nowrap me-1 mb-1 zipodButton" href="${url(`app/zipod/${data.report.book_record_animal_id}/add`)}">
                                Wyślij ponownie
                            </a>
                            `)
                            $('.zipod-modal-footer').prepend(zipodButton);
                    }else{
                        $('.zipod__error_row').hide();

                    }
                }

            }catch (e){
                toastAlert('Podczas pobierania danych wystąpił błąd. Spróbuj ponownie później', {type:'danger'})
            }
        })


}
